(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('SubFormulaDialogController', SubFormulaDialogController);

    SubFormulaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'SubFormula'];

    function SubFormulaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, SubFormula) {
        var vm = this;
//        vm.subFormula1 = [{monthNum:'3',inventoryMinDate:'90',quotaDateNum:'60',quota:'1.1',status:'1'}];
//        vm.subFormula = vm.subFormula1[0]
        vm.subFormula = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.subFormula.branchFormulaId != null || vm.subFormula.branchFormulaId != undefined) {
       	 vm.checkcreat = true;
       	vm.subFormula.isExit = true;
        }else{
    	   vm.subFormula.isExit = false;
    	   vm.subFormula.status="0";
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	$scope.clearMessage();
            vm.isSaving = true;
            if (vm.subFormula.isExit == true) {
            	
            	SubFormula.update(vm.subFormula,function(result){
          		  $scope.$emit('masterApp:subFormulaUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
        	},function(error) {
        		vm.isSaving = false;
		});
            } else {
            	SubFormula.save(vm.subFormula,function(result){
        		  $scope.$emit('masterApp:subFormulaUpdate', result);
                  $uibModalInstance.close(result);
                  vm.isSaving = false;
            	},function(error) {
            		vm.isSaving = false;
    		});
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('masterApp:subFormulaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
